import PosLandingTick from './PosLandingTick';
import {
  LANDING_BRAND_NAME, LANDING_BRAND_SUFFIX, LANDING_LOGO_URL,
} from '../constants/posLandingConst';
import {
  LOGIN_HEADLINE, LOGIN_SUBHEAD, LOGIN_ASSURANCES, LOGIN_BRAND_FOOT, LOGIN_TINY_NOTE,
} from '../constants/posLoginConst';
import '../css/PosLogin.css';

/**
 * The frame every sign-in screen shares (temp/login.html): the brand panel on
 * the left — a strip across the top on tablets and phones — and a centred
 * card on the right holding whatever the screen needs to ask.
 *
 * Only the frame lives here. The form itself is PosLoginForm, so the same
 * frame can also carry a card that is not a form (the till's "signed in, but
 * this role opens nothing" answer) without the two drifting apart.
 *
 * @param {object} props
 * @param {string} props.title - the card heading: the club's name on a till, the product's on /admin
 * @param {string} props.subtitle - the line under it, e.g. "Staff sign-in"
 * @param {React.ReactNode} props.children - the panel's contents
 * @param {React.ReactNode} [props.help] - the line under the panel
 * @param {string} [props.note] - the small print at the bottom of the card
 * @returns {JSX.Element}
 */
function PosLoginScreen({
  title, subtitle, children, help = null, note = LOGIN_TINY_NOTE,
}) {
  return (
    <div className="pl">
      <aside className="pl-brand">
        <div className="pl-lockup">
          <img src={LANDING_LOGO_URL} alt="" />
          <span>
            {LANDING_BRAND_NAME}
            {' '}
            <em>{LANDING_BRAND_SUFFIX}</em>
          </span>
        </div>

        <div className="pl-brand-mid">
          <h1>{LOGIN_HEADLINE}</h1>
          <p>{LOGIN_SUBHEAD}</p>
          <ul className="pl-assurances">
            {LOGIN_ASSURANCES.map((line) => (
              <li key={line}>
                <PosLandingTick />
                {line}
              </li>
            ))}
          </ul>
        </div>

        <p className="pl-brand-foot">{LOGIN_BRAND_FOOT}</p>
      </aside>

      <main className="pl-form-side">
        <div className="pl-card">
          <div className="pl-card-top">
            <div className="pl-badge">
              <img src={LANDING_LOGO_URL} alt={`${LANDING_BRAND_NAME} ${LANDING_BRAND_SUFFIX}`} />
            </div>
            <h2>{title}</h2>
            <p>{subtitle}</p>
          </div>

          <div className="pl-panel">{children}</div>

          {help && <p className="pl-help">{help}</p>}
          {note && <p className="pl-tiny">{note}</p>}
        </div>
      </main>
    </div>
  );
}

export default PosLoginScreen;
